import { Injectable } from '@angular/core';
import navigationMenu from '../assets/navigation_menu.json';
import { Crumb } from '@models/Crumb';
@Injectable()
export class BreadcrumbService {
  private crumbs: Crumb[] | any[];

  constructor() {}

  setCrumbs(currentRoute = '', currentElementName = '') {
    const urlParts = currentRoute.split('/').filter((item) => item);
    let crumbRoute = '';
    this.crumbs = urlParts.map((urlPart, index) => {
      const crumb = index === 0 ? { ...this.findSection(urlPart, navigationMenu) } : { label: urlPart };
      crumbRoute = `${crumbRoute}/${urlPart}`;
      crumb.route = crumbRoute;
      return crumb;
    });
    if (currentElementName) {
      this.crumbs[this.crumbs.length - 1].label = currentElementName;
    }
    return this.crumbs;
  }

  findSection(sectionName, navigationMenu) {
    if (sectionName && navigationMenu && navigationMenu.length) {
      let sectionFound;
      navigationMenu.some((action) => {
        sectionFound = action.route === sectionName ? action : this.findSection(sectionName, action.navigation_menu);
        return sectionFound;
      });
      return sectionFound;
    }
    return null;
  }
}
